import { Resource } from '../../security/permissions/rolePerimissionsUtil';

export interface SubmenuItem {
    label: string;
    route: string;
    resource: Resource;
    requiredAction: 'read' | 'write' | 'edit' | 'delete';
}

export type SubmenuConfig = Record<string, SubmenuItem[]>;

/**
 * Submenu configuration with permission requirements
 *
 * Each submenu item requires:
 * - label: Display name
 * - route: Navigation route
 * - resource: Permission resource type
 * - requiredAction: Required permission action (read/write/edit/delete)
 *
 * To add a new submenu:
 * 1. Add the configuration here
 * 2. Add icon mapping in LeftMenu.tsx getMenuIcon()
 * 3. Add rendering logic in LeftMenu.tsx renderMenuItem()
 * 4. Add state management in LeftMenu.tsx (e.g., isNewSubmenuOpen)
 */
export const SUBMENU_CONFIG: SubmenuConfig = {
    Users: [
        {
            label: 'Create User',
            route: '/create-user',
            resource: 'users',
            requiredAction: 'write',
        },
        {
            label: 'View Users',
            route: '/users',
            resource: 'users',
            requiredAction: 'read',
        },
    ],
    Requests: [
        {
            label: 'Create Request',
            route: '/create-request',
            resource: 'requests',
            requiredAction: 'write',
        },
        {
            label: 'View Requests',
            route: '/requests',
            resource: 'requests',
            requiredAction: 'read',
        },
    ],
    // Add more submenus here as needed
    // Example:
    // Reports: [
    //     {
    //         label: 'Create Report',
    //         route: '/create-report',
    //         resource: 'reports',
    //         requiredAction: 'write',
    //     },
    //     {
    //         label: 'View Reports',
    //         route: '/reports',
    //         resource: 'reports',
    //         requiredAction: 'read',
    //     },
    // ],
};

